module.exports = __webpack_public_path__ + "img/mobile-joystick.6d6f36d2.png";